import angular from 'angular';
import transFilter from './filter/trans';
import Translator from './service/translator';
import TranslationLoader from './service/translation-loader';

angular
    .module('paysera.translator', [])
    .factory('translator', Translator)
    .service('translationLoader', TranslationLoader)
    .filter('trans', transFilter)
;

export default 'paysera.translator';
